import React, { createContext, useContext, useState } from 'react';

const RoleContext = createContext();

export const ROLES = {
  OTHER: 'Other',
  DEVELOPERS: 'Developers',
  ADMINISTRATORS: 'Administrators',
};

export const RoleProvider = ({ children }) => {
  const [selectedRole, setSelectedRole] = useState(ROLES.OTHER);

  return <RoleContext.Provider value={{ selectedRole, setSelectedRole, ROLES }}>{children}</RoleContext.Provider>;
};

export const useRole = () => {
  const context = useContext(RoleContext);
  if (!context) {
    throw new Error('useRole must be used within a RoleProvider');
  }
  return context;
};
